import { createSlice } from '@reduxjs/toolkit';
import { LithosShopifySyncLogListApi, ShopifySyncLogListApi } from '../services/api';

export const LithosShopifySyncLogSlice = createSlice({
	name: 'lithosShopifySyncLog',
	initialState: {
		isLoading: false,
		ShopifySyncLogList: [],
		error: null,
	},
	reducers: {
		setLoading: (state) => {
			state.isLoading = true;
		},

		ShopifySyncLogData: (state, action) => {
			state.isLoading = false;
			state.ShopifySyncLogList = action.payload;
		},

		ShopifySyncLogErrorList: (state, action) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const { ShopifySyncLogData, setLoading, ShopifySyncLogErrorList } =
	LithosShopifySyncLogSlice.actions;

export default LithosShopifySyncLogSlice.reducer;

export const lithosShopifySyncLogListRequest = (queryString) => async (dispatch, getState) => {
	dispatch(setLoading());
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: getState()?.auth?.Token,
			},
		};
		const { data } = await LithosShopifySyncLogListApi(queryString, config);
		dispatch(ShopifySyncLogData(data));
	} catch (error) {
		dispatch(ShopifySyncLogErrorList(error));
	}
};
